<template>
  <div class="centered-div">
    <h1>Please Wait, You’re Being Redirected...</h1>
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
  name: 'ConfigurationPage'
}
</script>

<style scoped>
.centered {
  justify-content: center;
  display: flex;
}

p {
  line-height: 24px;
  font-size: 16px;
}

.centered-div {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.loader {
  --loader-color-1: var(--color-200);
  --loader-color-2: var(--color-600);
  width: 15px;
  aspect-ratio: 1;
  border-radius: 50%;
  animation: l5 1s infinite linear alternate;
}

@keyframes l5 {
  0% {
    box-shadow: 20px 0 var(--loader-color-1), -20px 0 var(--loader-color-2);
    background: var(--loader-color-1);
  }

  33% {
    box-shadow: 20px 0 var(--loader-color-1), -20px 0 var(--loader-color-2);
    background: var(--loader-color-2);
  }

  66% {
    box-shadow: 20px 0 var(--loader-color-2), -20px 0 var(--loader-color-1);
    background: var(--loader-color-2);
  }

  100% {
    box-shadow: 20px 0 var(--loader-color-2), -20px 0 var(--loader-color-1);
    background: var(--loader-color-1);
  }
}
</style>
